import { formatClientIdentity } from '@hopdrive/feature-move-planner/request';

/**
 * Dealer Portal's client version. The server refuses writes from builds whose
 * version is below its floor, and the app updater reloads open tabs urgently
 * when a deploy carries a higher version than the tab is running.
 *
 * Raise it by one, by hand, in the PR that makes older open tabs unsafe: a
 * changed request shape, a removed field, a write older code would get wrong.
 * Leave it alone for every other deploy. It is an integer because the server
 * compares it; the build sha travels with it for logs but can't be ordered.
 *
 * Raising it here only marks the build. The server floor is raised separately,
 * after this build is confirmed live (see docs/programs/app-updater.md).
 */
export const CLIENT_VERSION = 1;

declare const __BUILD_SHA__: string;

/** The build's short git sha, baked in by vite.config.ts; `dev` outside a Vite build. */
export const BUILD_SHA = typeof __BUILD_SHA__ === 'string' ? __BUILD_SHA__ : 'dev';

/**
 * `dealer;v=<CLIENT_VERSION>;sha=<sha>`. Sent as the `x-hopdrive-client` header
 * on every GraphQL request, and by the move planner as `clientIdentity` on
 * `requestVehicleMove`. Undefined only if the version or sha would break the
 * format; then requests carry no identity rather than a wrong one.
 */
export const CLIENT_IDENTITY: string | undefined = formatClientIdentity({ app: 'dealer', version: CLIENT_VERSION, sha: BUILD_SHA });
